import PropTypes from 'prop-types';
import React from 'react';
import map from 'lodash/map';
import experiments from '@letsdothis/experiments';

import {
  activeRule,
  experimentEnabled,
  experimentDisabled,
  experimentRowDetailContainer,
} from './styles.module.css';

const ExperimentRowDetail = (props) => {
  const { value, name, setOverrideState } = props;
  const overrideSelect = (
    <select
      id={`${name}-select`}
      defaultValue={value}
      onChange={setOverrideState}
    >
      {map(experiments[name].variants, 'name').map((variant) => (
        <option value={variant} key={variant}>
          {variant}
        </option>
      ))}
    </select>
  );

  return (
    <div className={experimentRowDetailContainer}>
      <div className={activeRule}>
        <span>Current Value</span>: {value}
      </div>
      <div className={activeRule}>
        <span>Override</span>: {overrideSelect}
      </div>
    </div>
  );
};

class ExperimentRow extends React.PureComponent {
  state = {
    isOpen: false,
  };

  setOverrideState = (e) => {
    e.preventDefault();
    this.props.updateExperiment(this.props.name, e.target.value);
  };

  handleClick = (event) => {
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <li>
        <span
          className={
            this.props.value !== 'control'
              ? experimentEnabled
              : experimentDisabled
          }
          onClick={this.handleClick}
        >
          {this.props.name}
        </span>
        {this.state.isOpen && (
          <ExperimentRowDetail
            setOverrideState={this.setOverrideState}
            {...this.props}
          />
        )}
      </li>
    );
  }
}

ExperimentRow.PropTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default ExperimentRow;
